const en = {
  common: {
    facts: "Key facts",
    why: "Why choose Hotel Ciutat Martorell",
    related: "You may also like",
    quoteEyebrow: "Tell us about your wedding",
  },
  nearSeat: {
    seoTitle: "Hotel near SEAT-CUPRA Martorell · 5 min from the plant",
    seoDesc: "4-star hotel 5 minutes from the SEAT-CUPRA plant and the Martorell industrial estates. Corporate rates, fibre WiFi, parking, restaurant and trains 100 m away.",
    eyebrow: "Hotel for SEAT-CUPRA visits",
    title: ["Your hotel 5 minutes", "from SEAT-CUPRA Martorell"],
    intro: "Suppliers, engineers, trainers and project teams stay with us because the plant and the Martorell industrial estates are a stone's throw away, and the train to Barcelona is 100 metres from the door.",
    facts: [
      { k: "SEAT-CUPRA plant", v: "5 min by car" },
      { k: "Renfe and FGC", v: "100 m" },
      { k: "Barcelona", v: "30 min" },
      { k: "El Prat airport", v: "25 min" },
    ],
    sections: [
      { h: "Designed for the working stay", p: "21 m² rooms with a desk, free fibre WiFi and air conditioning. Breakfast buffet from 06:30 to 10:30 so you make the morning shift on time, 24-hour reception for late arrivals and a Business Corner to print or finish a report." },
      { h: "Corporate rates and centralised invoicing", p: "For companies that visit the plant regularly we offer negotiated rates, centralised invoicing and quick handling of team bookings. Tell us your approximate volume of nights and we will prepare a proposal." },
      { h: "Meetings and training next to the plant", p: "Three daylight rooms from 35 to 220 m² for supplier training, kick-offs or audits, with projector, fibre and coffee breaks. Plus the My Bar restaurant for working lunches, with an executive menu Monday to Friday." },
    ],
    why: [
      "5 minutes by car from the SEAT-CUPRA plant and the Martorell industrial estates",
      "Private parking at the hotel (surcharge applies)",
      "Free fibre WiFi and a desk in every room",
      "Breakfast from 06:30 and 24-hour reception",
      "Corporate rates with centralised invoicing",
    ],
    faqTitle: "About staying near SEAT-CUPRA",
    cta: { title: "Book direct or ask for a corporate rate", text: "Book on the official website with the best rate guaranteed, or request a corporate rate for your team.", secondary: "Corporate rates", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "Business hotel" },
      { to: "meetingRooms", label: "Meeting rooms" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "Where to stay if you visit Martorell for work" },
    ],
  },
  nearMontserrat: {
    seoTitle: "Hotel near Montserrat · 20 min from the monastery",
    seoDesc: "4-star hotel in Martorell, 20 minutes by car from Montserrat and with FGC trains 100 m away towards the rack railway. A comfortable base for the monastery and Barcelona.",
    eyebrow: "Hotel for visiting Montserrat",
    title: ["Montserrat in 20 minutes,", "Barcelona in 30"],
    intro: "Martorell is the perfect halfway point: the monastery and the Montserrat mountains in the morning, Barcelona in the afternoon. And at night, a quiet room with a restaurant and parking.",
    facts: [
      { k: "Montserrat monastery", v: "20 min by car" },
      { k: "FGC train to the rack railway", v: "100 m from the hotel" },
      { k: "Barcelona", v: "30 min" },
      { k: "El Prat airport", v: "25 min" },
    ],
    sections: [
      { h: "How to get to Montserrat from the hotel", p: "By car, 20 minutes to the monastery or to the rack-railway car park in Monistrol. By public transport, the FGC station is 100 metres away: line R5 to Monistrol de Montserrat and up by rack railway, or to Montserrat-Aeri and up by cable car." },
      { h: "A day in the mountains, a night of rest", p: "After the basilica, the Escolania choir or a hike up to Sant Jeroni, come back to a 21 m² room with air conditioning, a shower bathroom and fibre WiFi. Dine at the My Bar restaurant: Mediterranean market cuisine and Penedès wines." },
      { h: "Combine Montserrat with Barcelona", p: "From the Renfe and FGC stations, Barcelona is about 30 minutes away. Spend one day in Montserrat and another in the city without changing hotels or fighting for parking downtown." },
    ],
    why: [
      "20 minutes by car from the Montserrat monastery",
      "FGC station 100 metres away, connecting to the rack railway and cable car",
      "Private parking so you can leave the car and travel by train",
      "My Bar restaurant with Mediterranean cuisine and Penedès wines",
      "Breakfast buffet from 06:30 to 10:30 for an early start in the mountains",
    ],
    faqTitle: "About visiting Montserrat from the hotel",
    cta: { title: "Book your base for Montserrat", text: "Book direct on the official website with the best rate guaranteed. Travelling as a group? Ask us for a proposal.", secondary: "How to get to the hotel", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "How to get to Montserrat from Martorell" },
      { to: "location", label: "Location and how to get here" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "What to visit near Martorell" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "Hotel with parking near Barcelona · 30 min by train",
    seoDesc: "4-star hotel with private parking in Martorell, 30 minutes from Barcelona. Leave the car and ride into the city by Renfe or FGC from the station 100 m away. Book direct.",
    eyebrow: "Hotel with parking",
    title: ["Park the car,", "Barcelona in 30 minutes"],
    intro: "If you are driving to Barcelona, sleeping outside the centre is calmer and simpler: private parking at the hotel and a direct train into the city 100 metres from the door.",
    facts: [
      { k: "Private parking", v: "at the hotel" },
      { k: "Renfe and FGC stations", v: "100 m" },
      { k: "Barcelona city centre", v: "30 min" },
      { k: "El Prat airport", v: "25 min" },
    ],
    sections: [
      { h: "Private parking at the hotel itself", p: "Private parking spaces for hotel guests (surcharge applies), with no hunting for a spot or paying central Barcelona car-park rates. Come and go as you please, with the car a few steps from your room." },
      { h: "Into Barcelona by train, no traffic", p: "The Renfe (Rodalies) and FGC stations are 100 metres away. In about 30 minutes you are in the centre; on the way back, the car is waiting. To explore the province, the A-2 and AP-7 motorways are right next door." },
      { h: "A complete hotel for your getaway", p: "92 rooms of 21 m² with fibre WiFi, the My Bar restaurant, a gym and a breakfast buffet from 06:30 to 10:30. Ideal for families and couples visiting Barcelona or Montserrat by car." },
    ],
    why: [
      "Private guest parking at the hotel",
      "Trains to Barcelona 100 metres away: Renfe and FGC",
      "30 minutes from Barcelona and 25 from the airport",
      "21 m² Double and Twin rooms with fibre WiFi",
      "Restaurant, gym and 24-hour reception",
    ],
    faqTitle: "About parking and getting to Barcelona",
    cta: { title: "Book with parking and forget about the car", text: "Book direct on the official website with the best rate guaranteed and let us know if you are coming by car.", secondary: "Hotel services", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "How to get from Martorell to Barcelona" },
      { to: "services", label: "Hotel services" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "Transport between Martorell and Barcelona" },
    ],
  },
  weddingsBaix: {
    seoTitle: "Wedding hotel in the Baix Llobregat · Martorell",
    seoDesc: "Celebrate your wedding in Martorell: Banquet Hall for up to 150 guests, cocktail for up to 200 on the terrace, tasting menu, bridal room and special rates for guests.",
    eyebrow: "Weddings in the Baix Llobregat",
    title: ["Your wedding in the Baix Llobregat,", "all under one roof"],
    intro: "Cocktail on the terrace, banquet in a 220 m² daylight hall, our own Mediterranean kitchen and 92 rooms so nobody has to drive home. 30 minutes from Barcelona and well connected to the whole county.",
    facts: [
      { k: "Banquet", v: "up to 150 guests" },
      { k: "Cocktail", v: "up to 200 people" },
      { k: "Banquet Hall", v: "220 m² with natural light" },
      { k: "Rooms", v: "92 for your guests" },
    ],
    sections: [
      { h: "Spaces: terrace, hall and rooms", p: "The welcome cocktail on the terrace, the banquet in the 220 m² partitionable Banquet Hall and, when the night ends, a complimentary bridal room and special rates for guests who stay over." },
      { h: "Our own kitchen and a tasting menu", p: "Our kitchen team prepares bespoke wedding menus with seasonal Mediterranean produce and Penedès wines. Before the big day we hold a tasting to settle every dish with the couple." },
      { h: "A coordinator from the first coffee", p: "A fixed quote within 48 hours, no surprises. A dedicated coordinator manages timings, suppliers, the DJ and the optional open bar so the couple only has to enjoy the day." },
    ],
    why: [
      "Easy for guests from Barcelona and the whole county: 30 min by car and trains 100 m away",
      "220 m² daylight hall and a terrace for the cocktail",
      "Complimentary bridal room and special rates for guests",
      "Prior tasting menu and our own Mediterranean kitchen",
      "Dedicated coordinator and a fixed quote within 48 hours",
    ],
    faqTitle: "About holding your wedding at the hotel",
    cta: { title: "Tell us how you picture your wedding", text: "Give us an approximate date, the number of guests and what you have in mind; we will reply with a proposal within 48 hours." },
    related: [
      { to: "weddings", label: "Weddings at the hotel" },
      { to: "events", label: "Events and celebrations" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "Banquet Hall" },
    ],
  },
};

export default en;
